import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { helper } from 'src/environments/helper';
import { CategoriiProiecteService } from '../categorii-proiecte.service';
import { ICategorieAddPayload, ICategorieForm } from '../categorii-proiecte.interface';
import { Observable, finalize, map } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { Generic } from 'src/app/interfaces/generic.interface';
import { CommonService } from 'src/app/services/common.service';

@Component({
    selector: 'app-add-categorii-proiecte',
    templateUrl: './add-categorii-proiecte.component.html',
    styleUrls: ['./add-categorii-proiecte.component.scss']
})
export class AddCategoriiProiecteComponent implements OnInit {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    defaultParameter: { name: string; id: string } = {
        name: '--Alegeți--',
        id: '-1',
    };

    sections$!: Observable<Generic[]>;

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        sectiune: new FormControl('', []),
        observatii: new FormControl('', []),
    });

    constructor(
        private dialogRef: MatDialogRef<AddCategoriiProiecteComponent>,
        private categoriiProiecteService: CategoriiProiecteService,
        private notificationService: NotificationService,
        private authService: AuthService,
        private commonService: CommonService,
    ) { }

    ngOnInit(): void {
        this.loadSectiuniProiecte();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    loadSectiuniProiecte() {
        this.isLoading = true;
        this.sections$ = this.commonService.getSectiuniProiecte().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isLoading = false))
        );
    }

    submitForm() {
        this.isLoading = true;

        const { name, observatii, sectiune } = this.form.value as ICategorieForm;
        const payload: ICategorieAddPayload = {
            name,
            observatii,
            sectiune
        };

        this.categoriiProiecteService
            .addCategorie(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
